import * as React from 'react'
import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'
import axios from 'axios'
import useDebounceFnc from '../../../../../../utils/customHooks/useDebounceFnc'
import {CircularProgress} from '@mui/material'
import { ReferencesModel } from '../../references/models'

interface Factory {
  id?: number
  name: string
  description?: string
  costManufact?: number
  costManufactPerProduct?: number
  factoryId?: number
  createdAt?: string
}

interface SelectReferenceProps {
  onChange: (opt: ReferencesModel | null) => void
}

const SelectReferences: React.FC<SelectReferenceProps> = ({onChange}) => {
  const [value, setValue] = React.useState<ReferencesModel | null>(null)
  const [inputValue, setInputValue] = React.useState('')
  const [options, setOptions] = React.useState<readonly ReferencesModel[]>([])
  const [loading, setLoading] = React.useState(false)

  const fetch = useDebounceFnc(
    React.useCallback(async (input: string) => {
      try {
        if (input === '') {
          setOptions([])
          return
        }
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/references`,
					{
						params: {
							name: input,
						}
					}
        )
        const newOpt:  ReferencesModel = {
          name: input,
          costManufact: undefined,
          description: undefined,
          factoryId: 0,
					referencesSupplies: []
        }
        if (res.data.find((opt: ReferencesModel) => opt.name === input) !== undefined) {
          setOptions(res.data)
          return
        }
        setOptions([...res.data, newOpt])
      } catch (error) {
        console.log(error)
        setOptions([])
      } finally {
        setLoading(false)
      }
    }, []),
    500
  )

  React.useEffect(() => {
    fetch(inputValue)
    return () => {
      setLoading(true)
    }
  }, [inputValue])

  return (
    <Autocomplete
      // sx={{ width: 300 }}
      getOptionLabel={(option) =>
        option.factoryId === 0 ? `Crear referencia: ${option.name}` : option.name
      }
      isOptionEqualToValue={(opt, val) => opt.name === val.name && opt.factoryId === val.factoryId}
      loading={loading}
      filterOptions={(x) => x}
      options={options}
      autoComplete
      includeInputInList
      filterSelectedOptions
      value={value}
      noOptionsText='No hay referencias'
      onChange={(event: any, val: ReferencesModel | null) => {
        // setOptions(newValue ? [newValue, ...options] : options);
        const newValue = val
        if (val !== null && val.factoryId === 0) {
          //@ts-ignore
          newValue.factoryId = undefined
        }
        setValue(newValue)
        onChange(newValue)
      }}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue)
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label='Referencia'
          fullWidth
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress color='inherit' size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  )
}

export default SelectReferences
